import { render, staticRenderFns } from "./ModalContentInvoiceDelete.vue?vue&type=template&id=5c87c91e&scoped=true&"
import script from "./ModalContentInvoiceDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentInvoiceDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentInvoiceDelete.vue?vue&type=style&index=0&id=5c87c91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c87c91e",
  null
  
)

export default component.exports